import PropTypes from 'prop-types'
import { List, Button } from 'antd'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  center: {
    textAlign: 'center',
  },
})

export default function Locations({
  onManage,
  locations = []
}) {
  const classes = useStyles()

  return (
    <List
      bordered
      dataSource={locations}
      footer={
        <div className={classes.center}>
          <Button type="link" onClick={onManage}>
            Manage
          </Button>
        </div>
      }
      renderItem={item => <List.Item>{item.name}</List.Item>}
    />
  )
}

Locations.propTypes = {
  locations: PropTypes.arrayOf({}),
  onManage: PropTypes.func.isRequired,
}
